import styled from '@emotion/styled'
import { Table, Card, Col } from 'react-bootstrap'

export const SummarySheet = styled('div')`
  label: SummarySheet;
  max-width: 720px;
  margin: 0 auto;
  padding: ${(props) => props.pdf ? '0px': '15px'};
`

export const SummaryHeaderBlock = styled('div')`
  label: HeaderBlock;
  color: ${(props) => props.theme.colors.primary};
  font-size: 19px;
`

export const SummaryTable = styled(Table)`
  color: #000;
  label: SummaryTable;
  font-size: 12px;
  margin-top: 4px;
  border: 2px solid ${(props) => props.theme.colors.primary};
  td {
    position: relative;
    small {
      position: absolute;
      top: 0px;
      font-size: 7px;
      font-weight: bold;
    }
  }
  th {
    font-weight: 800;
  }
  > thead > tr > th {
    border-color: inherit;
    color: #000;
    text-align: center;
    background-color: ${(props) => props.theme.colors.secondary};
  }
  td {
    border-left: 0;
  }
  tr > td:last-child {
    border-right: 0;
  }
  tr:last-child > td {
    border-bottom: 0;
  }
  td:nth-of-type(2) {
    text-align: right;
  }
  li {
    font-size: 10px;
    a {
      text-decoration: underline;
      color: #000;
    }
  }
  th,
  td {
    padding: 3px;
  }
`

export const SummaryTableDisclaimer = styled('tr')`
  label: SummaryTableDisclaimer;
  font-size: ${(props)=> props.pdf ? '10pt':'14pt'};
`

export const SummaryTableHeader = styled('tr')`
  label: SummaryTableHeader;
  color: ${(props) => props.theme.colors.primary};
  font-size: 18px;
  line-height: 12px;
  position: relative;
  > td > small {
    font-size: 11px;
  }
  td > span {
    font-size: 10px;
  }

  li {
    color: #000;
  }
`
export const BoldTH = styled('td')`
  label:  BoldTH;
  font-weight: 900;
`

export const MXSummaryTable = styled(Table)`
  color: #000;
  label: MXSummaryTable;
  font-size: 12px;
  margin-top: 4px;
  border: none;
  td {
    position: relative;
    small {
      position: absolute;
      top: 0px;
      font-size: 7px;
      font-weight: bold;
    }
  }
  th {
    font-weight: 800;
  }
  td {
    border: none;
  }
  tr {
    border-bottom: 1px solid black;
  }
  th,
  td {
    padding: 3px;
  }
`

export const MXSummaryHeader=styled.div`
  label: MXSummaryHeader;
  background-color:${(props) => props.theme.backgrounds.backGround2};
  min-height: 70px; 
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`


export const BoldText = styled('b')`
  label: BoldText;
  font-size: 21px;
`
export const PdfTitle = styled('div')`
  label: pdfTitle;
  text-align: center;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.textLightblack
      : props.theme.colors.primary};
`
export const PdfLogo = styled('img')`
  label: pdfLogo;
  height: 54px;
  margin-bottom: 10px;
`
export const PdfTnC = styled('p')`
  label: PdfTnC;
  color: #666;
  font-size: 14px;
`

export const InfoSection = styled('div')`
  label: InfoSection;
  font-size: 10px;
`

export const StyledCard = styled(Card)`
  label: StyledCard;
  border-color: ${(props) => props.theme.colors.primary};
  margin-bottom: 1rem;
`

export const StyledCardHeader = styled(Card.Header)`
  label: StyledCardHeader;
  border-bottom: none;
  background-color: ${(props) => props.theme.colors.primary};
`

export const StyledCardHeaderText = styled.div`
  label: StyledCardHeaderText;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
`

export const CardValueHeading = styled(Col)`
  label: CardValueHeading;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
`

export const CardValueValue = styled(Col)`
  label: CardValueValue;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: right;
`

export const CarTitle = styled.div`
  label: CarTitle;
  text-align: center;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '18px' : '34px')};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 600 : 900)};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const CarDescriptor = styled.div`
  label: CarDescriptor;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  padding-left: 9px;
  padding-right: 9px;
  text-align: center;
`

export const DisclaimerDiscoverMore = styled.span`
  label: DisclaimerDiscoverMore;
  margin-left: 9px;
  font-size: ${(props)=> props.theme.font.size.smaller};
`

export const DisclaimerImptInfo = styled.p`
  label:  DisclaimerImptInfo;
  font-weight: bold;
  color: ${(props)=> props.theme.colors.primary};
  font-size: ${(props)=> props.theme.font.size.medium};
  line-height: 12px;
`

export const SummarySheetGreyRow = styled.td`
  label: SummarySheetGreyRow;
  background-color: #F7F7F7;
`